import React from 'react';
import TrustBar from '@/components/TrustBar';
import MissionSection from '@/components/MissionSection';
import CoreFunctions from '@/components/CoreFunctions';
import TalentRoster from '@/components/TalentRoster';
import CorporateServices from '@/components/CorporateServices';
import CaseStudiesSection from '@/components/CaseStudiesSection';
import PortfolioSection from '@/components/portfolio/PortfolioSection';
import ResultsSection from '@/components/ResultsSection';
import OfficesSection from '@/components/OfficesSection';
import CalendlySection from '@/components/CalendlySection';
import Footer from '@/components/Footer';

// Everything below the fold, in its own chunk so the hero can paint before
// this JavaScript is parsed.
export default function HomeBelowFold() {
  return (
    <>
      <TrustBar />
      <MissionSection />
      <CoreFunctions />
      <TalentRoster />
      <CorporateServices />
      <PortfolioSection />
      <ResultsSection />
      <CaseStudiesSection />
      <OfficesSection />
      <CalendlySection />
      <Footer />
    </>
  );
}